<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="会员卡号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入会员卡号查询" v-model="queryParam.supplier"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="联系人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入联系人查询" v-model="queryParam.contacts"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="手机号码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入手机号码查询" v-model="queryParam.telephone"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" @click="handleAdd" type="primary" icon="plus">新增</a-button>
          <a-button v-if="btnEnableList.indexOf(1)>-1" @click="batchDel" icon="delete">删除</a-button>
          <a-button v-if="btnEnableList.indexOf(1)>-1" @click="handleImportXls()" icon="import">导入</a-button>
          <a-button v-if="btnEnableList.indexOf(3)>-1" @click="handleExportXls('会员信息')" icon="download">导出</a-button>
        </div>
        <!-- table区域 -->
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :scroll="scroll"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">
          <span slot="action" slot-scope="text, record">
            <a @click="handleDetail(record)">详情</a>
            <a-divider type="vertical" />
            <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="确定删除吗?" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
            </a-popconfirm>
          </span>
          <template slot="customRenderFlag" slot-scope="enabled">
            <a-tag v-if="enabled" color="green">启用</a-tag>
            <a-tag v-else color="orange">禁用</a-tag>
          </template>
          <template slot="levelSlot" slot-scope="text, record">
            <a-tag v-if="record.levelName" color="blue">{{ record.levelName }}</a-tag>
            <span v-else>-</span>
          </template>
        </a-table>
        <!-- 表单区域（基础信息沿用主框架会员弹窗） -->
        <member-modal ref="modalForm" @ok="modalFormOk"></member-modal>
        <import-file-modal ref="modalImportForm" @ok="modalFormOk"></import-file-modal>
        <member-detail-modal ref="detailModal" @ok="modalFormOk"></member-detail-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import MemberModal from '@/views/system/modules/MemberModal'
import ImportFileModal from '@/components/tools/ImportFileModal'
import MemberDetailModal from './modules/MemberDetailModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'MemberList',
  mixins: [JeecgListMixin],
  components: {
    MemberModal,
    ImportFileModal,
    MemberDetailModal
  },
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18, offset: 1 },
      queryParam: {
        supplier: '',
        type: '会员',
        contacts: '',
        telephone: ''
      },
      urlPath: '/plugin/member/list',
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200']
      },
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        { title: '操作', dataIndex: 'action', width: 160, align: 'center', scopedSlots: { customRender: 'action' } },
        { title: '会员卡号', dataIndex: 'supplier', width: 150, align: 'left' },
        { title: '联系人', dataIndex: 'contacts', width: 70, align: 'left' },
        { title: '手机号码', dataIndex: 'telephone', width: 100, align: 'left' },
        { title: '等级', dataIndex: 'levelName', width: 90, align: 'center', scopedSlots: { customRender: 'levelSlot' } },
        { title: '累计消费', dataIndex: 'consumeTotal', width: 100, align: 'right' },
        { title: '预付款', dataIndex: 'advanceIn', width: 80, align: 'right' },
        { title: '电子邮箱', dataIndex: 'email', width: 150, align: 'left' },
        { title: '状态', dataIndex: 'enabled', width: 60, align: 'center', scopedSlots: { customRender: 'customRenderFlag' } }
      ],
      url: {
        list: '/api/plugin/member/members',
        delete: '/supplier/delete',
        deleteBatch: '/supplier/deleteBatch',
        importExcelUrl: '/supplier/importMember',
        exportXlsUrl: '/supplier/exportExcel'
      }
    }
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
    }
  },
  methods: {
    searchReset() {
      this.queryParam = { type: '会员' }
      this.loadData(1)
    },
    handleAdd() {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = '新增'
      this.$refs.modalForm.disableSubmit = false
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
      if (this.btnEnableList.indexOf(1) === -1) {
        this.$refs.modalForm.isReadOnly = true
      }
    },
    handleDetail(record) {
      this.$refs.detailModal.show(record)
    },
    handleImportXls() {
      let importExcelUrl = this.url.importExcelUrl
      let templateUrl = '/doc/member_template.xls'
      let templateName = '会员Excel模板[下载]'
      this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
      this.$refs.modalImportForm.title = '会员导入'
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less'
</style>
